import React from "react";
import { Layout, Button, Row, Col } from "antd";
import "../../components/css/Topbar.css";

import { useAuthContext } from "../../hooks/useAuthContext";
import { UserTop } from "./Users/UserTop";
import useSidebarTrigger from "../../store/useSidebarTrigger";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

const { Header } = Layout;

export function TopBar() {
  const { user } = useAuthContext();

  const { sidebarCollapse, setSidebarCollapse } = useSidebarTrigger();

  return (
    <Header
      style={{
        zIndex: 100,
        paddingLeft: 0,
      }}
      className="topbar-container"
    >
      <Row justify="space-between">
        <Col flex="auto">
          <Button
            type="text"
            icon={sidebarCollapse ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setSidebarCollapse(!sidebarCollapse)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
              color: "white",
            }}
          />
        </Col>

        <Col flex="none">
          <UserTop user={user} />
        </Col>
      </Row>
    </Header>
  );
}
